import { BASE_URL } from "../config/api";

const getToken = () => localStorage.getItem("token");

// Add Album
export const addAlbum = async (payload) => {
  const response = await fetch(`${BASE_URL}/gallery/createAlbum`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to add album");
  return data;
};

// Update Album - FIXED: Ensure album_id is properly passed
export const updateAlbum = async (albumData) => {
  if (!albumData.album_id) {
    throw new Error("Album ID is required for update");
  }

  const response = await fetch(`${BASE_URL}/gallery/updateAlbum/${albumData.album_id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(albumData),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to update album");
  return data;
};

// Fetch all albums
export const fetchAllAlbums = async () => {
  const response = await fetch(`${BASE_URL}/gallery/fetchAllAlbums`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to fetch albums");
  return data.albums || [];
};

// Fetch album by ID
export const fetchAlbumById = async (albumId) => {
  const response = await fetch(`${BASE_URL}/gallery/fetchAlbumById/${albumId}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to fetch album");
  return data;
};

// Upload images
export const uploadAlbumImages = async (formData) => {
  const response = await fetch(`${BASE_URL}/gallery/uploadImages`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken()}` },
    body: formData,
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Image upload failed");
  return data;
};

// Fetch images by album
export const fetchImagesByAlbumId = async (albumId) => {
  const response = await fetch(`${BASE_URL}/gallery/fetchImagesByAlbumId/${albumId}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to fetch images");
  return data;
};

// Delete image by ID
export const deleteImageById = async (imageId) => {
  const response = await fetch(`${BASE_URL}/gallery/deleteImage/${imageId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Failed to delete image");
  return data;
};